export { default } from './MiniPaywall';
